import { render, staticRenderFns } from "./ProductImage.vue?vue&type=template&id=e6be8a40"
import script from "./ProductImage.vue?vue&type=script&lang=js"
export * from "./ProductImage.vue?vue&type=script&lang=js"
import style0 from "./ProductImage.vue?vue&type=style&index=0&id=e6be8a40&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports